//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["featureTag","nJointCurves"],"GetJointCurvesFromWeldFeature",{R_:{jointCurves:"Curve[]"}},1,0],[["featureTag","nDesignFeatures"],"GetDesignFeatureFromWeldFeature",{R_:{designFeatures:"NXObject[]"}},1,0]],[]];
SPLM.Weld.WeldCpdUtils = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Weld.WeldCpdUtils";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;